import * as React from "react";
import "./GenericCheckBoxInput.css";
import { HRQuestionId } from "../../messages";
import { HRQuestionWithStatus } from "../../models/HR";
import { HRQuestion, PossibleAnswer, PossibleAnswerId } from "../../messages/HR";
import { GenericInputHeader } from "./GenericInputHeader";
import { HRQuestionTemplateId } from "../../messages/ObjectIds";
import { Globals } from "../../Globals";

interface GenericDropDownInputProps {
    hrDropDownQuestionWithStatus: HRQuestionWithStatus<HRQuestion.DropDownQuestion>;
    isHidden: boolean;
    onChange: (newVal: PossibleAnswerId | null, id: HRQuestionId) => void;
    onBlur: (questionId: HRQuestionId) => void;
}

export class GenericDropDownInput extends React.Component<GenericDropDownInputProps> {
    private readonly defaultVal: PossibleAnswer | undefined;

    constructor(props: GenericDropDownInputProps) {
        super(props);

        this.defaultVal = props.hrDropDownQuestionWithStatus.question.possibleAnswers.find((answer) => props.hrDropDownQuestionWithStatus.question.chosenAnswerId === answer.id);
        if (this.defaultVal === undefined) {
            const lastPick = Globals.getAnswerByTemplateId(props.hrDropDownQuestionWithStatus.question.textId);
            if (lastPick !== null) {
                this.defaultVal = props.hrDropDownQuestionWithStatus.question.possibleAnswers.find((answer) => answer.id === lastPick);
                this.handleChoiceClick(lastPick, props.hrDropDownQuestionWithStatus.question.id);
            }
        }
    }

    handleChoiceClick(answerId: number, questionId: HRQuestionId) {
        if (answerId === -1) {
            this.props.onChange(null, questionId);
        } else {
            this.props.onChange(answerId, questionId);
        }

        this.props.onBlur(questionId);
    }

    render() {
        const question = this.props.hrDropDownQuestionWithStatus.question;
        const status = this.props.hrDropDownQuestionWithStatus.status;
        return (
            <div className="control-group" style={this.props.isHidden ? { display: "none" } : { display: "" }}>
                <GenericInputHeader status={status} questionText={question.questionText}/>
                <div className="GenericCheckBoxInput__root">
                    <div className="bp3-select bp3-fill">
                        <select
                            required={question.isMandatory}
                            id={HRQuestionTemplateId.unwrap(question.textId)}
                            className={"form-control"}
                            onChange={(e) => this.handleChoiceClick(+e.target.value, question.id)}
                            defaultValue={this.defaultVal === undefined ? undefined : "" + this.defaultVal.id}
                        >
                            <option value={-1}/>
                            {question.possibleAnswers.map((answer) => {
                                return (
                                    <option
                                        value={answer.id}
                                        key={answer.text + answer.id}
                                    >
                                        {answer.text}
                                    </option>
                                );
                            })}
                        </select>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/inputs/GenericDropDownInput.tsx